import { useSelector } from 'react-redux'
import { selectLatestAgentTurn, type AgentTurnStream } from './select-agent-turn.js'

export type { AgentTurnStream } from './select-agent-turn.js'

/**
 * Subscribes to the `agentStream` RTK Query cache and returns the most-recent
 * entry whose `originalArgs.agentId` matches `agentId`. Returns `null` when no
 * such entry exists. The lookup itself is `selectLatestAgentTurn`, shared with
 * commands that read the same state through `getState`.
 */
export const useAgentTurnStream = (agentId: string | undefined): AgentTurnStream | null =>
  useSelector(state => selectLatestAgentTurn(state, agentId))
